import React from "react";

export default (...components) => {
  return props => {
    return components.reduceRight((acc, Component) => {
      return <Component>{acc}</Component>;
    }, props.children);
  };
};
